import React, { useEffect, useState } from 'react';
import { hasChildren } from '../TeamPerformance/TeamUtils';
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { TableRow, TableCell, TableHead, TableBody, Table, Button, Grid, Alert, IconButton, Tooltip, Divider, Menu, MenuItem } from '@mui/material';
import Select from 'react-select';
import './TeamPerformance.css'
import { PeriodList } from '../../../../utils/PeriodList';
import { CustomizedSnackbar } from '../../../../shared';
import { axiosFetch } from '../../../../utils/AxiosFetch';
import { useDispatch } from 'react-redux';
import { SnackbarActions } from '../../../../redux/actions/snackbar.actions';
import { useNavigate } from 'react-router';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';




var userDetails =
    localStorage.getItem("argus_user") !== null
        ? localStorage.getItem("argus_user")
        : null;
var userType =
    userDetails !== null && JSON.parse(userDetails).usertype !== null
        ? JSON.parse(userDetails).usertype
        : "";
var userid =
    userDetails !== null && JSON.parse(userDetails).userid !== null
        ? JSON.parse(userDetails).userid
        : "";
export default function TeamPerformance() {

    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [teamList, setTeamList] = useState([]);
    const [periodOption, setPeriodOption] = useState([]);


    const dispatch = useDispatch();
    const navigate = useNavigate();

    function getCurrentSessionDetails() {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        var value = null;
        if (currentMonth <= 6) {
            value = {
                lable: currentYear + "-" + 'H1',
                value: currentYear + "-" + 'H1'
            }

        }
        else {
            value = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }

        var list = PeriodList(3, "half");
        console.log(list);
        var restrictYear = null;
        var exactperiod;
        if (currentMonth <= 6) {
            restrictYear = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }
        if (restrictYear !== null) {
            exactperiod = list.filter(list => list.value !== restrictYear.value);
        } else {
            exactperiod = list;
        }

        setSelectedPeriod(exactperiod.filter(list => list.value === value.value)[0]);
        loadTeamDetails(value)
    }
    useEffect(() => {
        getCurrentSessionDetails();
        getPeriodList();
    }, [])
    const getPeriodList = () => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        var list = PeriodList(3, "half");
        console.log(list);
        var restrictYear = null;
        var exactperiod;
        if (currentMonth <= 6) {
            restrictYear = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }
        if (restrictYear !== null) {
            exactperiod = list.filter(list => list.value !== restrictYear.value);
        } else {
            exactperiod = list;
        }
        setPeriodOption(exactperiod)
    }



    const handleChangePeriod = (obj) => {
        setSelectedPeriod(obj);
    }



    const loadTeamDetails = (sessionObj) => {


        axiosFetch({
            method: "post",
            url: `/performance/list/team`,
            requestConfig: {
                "year": sessionObj.value.split('-')[0],
                "session": sessionObj.value.split('-')[1]
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    setTeamList(res.data);
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
    }

    const handleSearch = () => {
        loadTeamDetails(selectedPeriod);
    }

    const clearFilter = () => {
        setSelectedPeriod(null);
        setTeamList([]);
        getCurrentSessionDetails()
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <div className='filter' style={{ marginTop: "0px" }}>
                    {/* dept, period, team,keywords */}
                    {/* <Card className='filters'> */}
                    <h3 className='filters'>Filters </h3>
                    {/* <ValidatorForm> */}
                    <Grid container xs={12} spacing={2} style={{ marginBottom: '20px' }}>

                        <Grid item xs={3}>
                            <Select placeholder="Select Period" options={periodOption} onChange={handleChangePeriod} value={selectedPeriod} />
                        </Grid>
                        <Grid item xs={3}>
                            <Button className='theme-btn cancel-btn' variant="contained" onClick={clearFilter} >Clear</Button>&nbsp;&nbsp;
                            <Button className='theme-btn' sx={{ marginRight: "10px" }} variant="contained" onClick={handleSearch}>Search</Button>
                        </Grid>
                    </Grid>

                    {/* </ValidatorForm> */}
                    {/* </Card> */}
                    <CustomizedSnackbar />
                </div>
            </Grid>

            {teamList.length ? <Grid item xs={12}>


                <Table className='pf-list-bg'>
                    <TableHead>
                        <TableRow className='pf-list'>
                            <TableCell></TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Designation</TableCell>
                            <TableCell>Period</TableCell>
                            <TableCell>OKR Score</TableCell>
                            <TableCell>Voice Score</TableCell>
                            <TableCell>Training Score</TableCell>
                            <TableCell>Overall Score</TableCell>
                            <TableCell>Proposed %</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Actions</TableCell>


                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {teamList.map((item, key) => <Items key={key} item={item} />)}
                    </TableBody>
                </Table>
            </Grid> : <Alert severity='error'>No Review History</Alert>}
        </Grid >
    )


}

const Items = ({ item }) => {
    const MenuComponent = hasChildren(item) ? MultiLevel : SingleLevel;
    return <MenuComponent item={item} />
};

const SingleLevel = ({ item }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open_Menu = Boolean(anchorEl);
    const [formId, setFormId] = useState('');
    const [statusId, setStatusId] = useState('');
    const [managerId, setManagerId] = useState('');
    const [isRestrictApprove, setIsRestrictApprove] = useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [reportingPersonId, setReportingPersonId] = useState('');
    const [text, setText] = useState('');

    const handleClickOpenDialog = (id) => {
        setFormId(id)
        setOpenDialog(true);
    };

    const handleCloseDiloag = () => {
        setOpenDialog(false);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleMenu = (event, formId, statusId, managerId, reportingPersonId) => {

        setAnchorEl(event.currentTarget);
        setFormId(formId);
        setStatusId(statusId);
        setManagerId(managerId);
        setReportingPersonId(reportingPersonId);

        if (localStorage.getItem('argus_user') !== null && JSON.parse(localStorage.getItem('argus_user')).userid === reportingPersonId) {
            setText('Review');
        }
        else {
            setText('View');
        }
        if (statusId === '3' && localStorage.getItem('argus_user') !== null && JSON.parse(localStorage.getItem('argus_user')).userid == managerId) {
            setIsRestrictApprove(false);
        }
        else {
            setIsRestrictApprove(true);
        }

    }

    const handleForm = () => {

            axiosFetch({
                method: 'post',
                url: `/performance/review/approve/${formId}`
            })
                .then((res) => {
                    if (res.status === 200) {
                        setOpenDialog(false);
                        dispatch(SnackbarActions(true, "success", "Request Approved!"));
                        window.location.reload();
                    } else if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", `${res.data}`));
                    }
                    else if (res.status === 401) {
                        window.location.href = '/';
                    }

                })
    }

    const handleView = (formid, statusid, reviewermanagerid, reportingid) => {

        setFormId(formid)
        if (parseInt(statusid) !== 1) {
            if (parseInt(reviewermanagerid) === (localStorage.getItem('argus_user') !== null && JSON.parse(localStorage.getItem('argus_user')).userid)) {
                // if (parseInt(statusid) === 3) {
                navigate(`/form/${formid}`);
                // }
            }
            else {
                navigate(`/form/${formid}`);
            }
        }
        else {
            dispatch(SnackbarActions(true, "info", "You can view the form once the employee has initiated it"));
        }

    }
    return (
        <>
            <TableRow>
                <TableCell className='pf-sec-txt-empty' />
                <TableCell className='pf-sec-txt-nme '> {item.employeeName !== null ? item.employeeName : '-'}</TableCell>
                <TableCell className='pf-sec-txt-degn txt-off'>{item.emailId !== null ?
                    <Tooltip title={item.emailId} arrow>
                        <span>{item.emailId}</span></Tooltip> : '-'}</TableCell>
                <TableCell className='pf-sec-txt-perd'>{item.designation !== null ? item.designation : '-'}</TableCell>
                <TableCell className='pf-sec-txt-okr'>{item.period !== null ? item.period : '-'}</TableCell>

                <TableCell className='pf-sec-txt-vscor'>{item.okrScore !== null ? item.okrScore : '-'}</TableCell>
                <TableCell className='pf-sec-txt-tscor'>{item.voiceScore !== null ? item.voiceScore : "-"}</TableCell>
                <TableCell className='pf-sec-txt-oscor'>{item.trainingScore !== null ? item.trainingScore : '-'}</TableCell>
                <TableCell className='pf-sec-txt-proposed'>{item.overAllScore !== null ? item.overAllScore : '-'}</TableCell>
                <TableCell className='pf-sec-txt-status'>{item.proposedPercentage !== null ? item.proposedPercentage : '-'}</TableCell>
                <TableCell className='pf-sec-txt-status-name'>{item.statusName !== null ? item.statusName : '-'}</TableCell>

                <TableCell className='pf-sec-txt-btn'>
                    {(parseInt(item.reportingPersonId) === userid) && (parseInt(item.statusId) !== 5) ?
                        <Button className='review' onClick={() => handleView(item.formId, item.statusId, item.reviewerManagerId, item.reportingPersonId)}>Review</Button> :
                        <Button className="view onbt" onClick={() => handleView(item.formId, item.statusId, item.reviewerManagerId, item.reportingPersonId)}>View</Button>
                    }
                    {parseInt(item.statusId) === 3 && (parseInt(item.reviewerManagerId) === userid) ?
                        <Button className='apprval secbt' onClick={() => handleClickOpenDialog(item.formId)}>Approve</Button> :
                        ""
                    }
                    {/* <IconButton className={parseInt(item.reportingPersonId) == userid && parseInt(item.statusId) !== 5 ? 'review' : 'view'} 
                        onClick={(e) => toggleMenu(e, item.formId, item.statusId, item.reviewerManagerId, item.reportingPersonId)}>                  
                            <MoreHorizIcon />
                        </IconButton> */}
                    {/* <Button >{parseInt(item.reportingPersonId) == userid && parseInt(item.statusId) !== 5 ? "Review" : item.statusId === '3' && parseInt(item.reviewerManagerId) === userid ? 'Approve' : "View"}</Button> */}
                </TableCell>
            </TableRow>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open_Menu}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
            >
                <MenuItem onClick={() => handleView()}>{text}</MenuItem>
                <Divider />
                <MenuItem disabled={isRestrictApprove} onClick={() => handleClickOpenDialog()}>Approve</MenuItem>
            </Menu>
            <Dialog
                open={openDialog}
                onClose={handleCloseDiloag}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to approve this request?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className='theme-btn cancel-btn' onClick={handleCloseDiloag}>No</Button>
                    <Button className='theme-btn' autoFocus onClick={handleForm}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const MultiLevel = ({ item }) => {
    const navigate = useNavigate();
    const { members: children } = item;
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [formId, setFormId] = useState('');
    const [statusId, setStatusId] = useState('');
    const [managerId, setManagerId] = useState('');
    const [isRestrictApprove, setIsRestrictApprove] = useState(false);
    const [reportingPersonId, setReportingPersonId] = useState('');
    const [text, setText] = useState('');
    const [openDialog, setOpenDialog] = React.useState(false);
    const open_Menu = Boolean(anchorEl);

    const dispatch = useDispatch();

    const handleClick = () => {
        setOpen((prev) => !prev);
    };

    const handleClickOpenDialog = (id) => {
        setFormId(id)
        setOpenDialog(true);
    };

    const handleCloseDiloag = () => {
        setOpenDialog(false);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleMenu = (event, formId, statusId, managerId, reportingPersonId) => {

        if (localStorage.getItem('argus_user') !== null && JSON.parse(localStorage.getItem('argus_user')).userid === reportingPersonId) {
            setText('Review');
        }
        else {
            setText('View');
        }

        if (statusId === '3' && localStorage.getItem('argus_user') !== null && JSON.parse(localStorage.getItem('argus_user')).userid === managerId) {
            setIsRestrictApprove(false);
        }
        else {
            setIsRestrictApprove(true);
        }
        setAnchorEl(event.currentTarget);
        setFormId(formId);
        setStatusId(statusId);
        setManagerId(managerId);
        setReportingPersonId(reportingPersonId)
        // handleForm(formId, statusId, managerId);
    }
    const handleForm = () => {

        axiosFetch({
            method: 'post',
            url: `/performance/review/approve/${formId}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setOpenDialog(false);
                    dispatch(SnackbarActions(true, "success", "Request Approved!"));
                    window.location.reload();
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", `${res.data}`));
                }
                else if (res.status === 401) {
                    window.location.href = '/';
                }

            })

    }

    const handleView = (formid, statusid, reviewermanagerid, reportingid) => {

        setFormId(formid)
        if (parseInt(statusid) !== 1) {
            if (parseInt(reviewermanagerid) === (localStorage.getItem('argus_user') !== null && JSON.parse(localStorage.getItem('argus_user')).userid)) {
                // if (parseInt(statusid) === 3) {
                navigate(`/form/${formid}`);
                // }
            }
            else {
                navigate(`/form/${formid}`);
            }
        }
        else {
            dispatch(SnackbarActions(true, "info", "You can view the form once the employee has initiated it"));
        }

        // }
    }

    return (
        <React.Fragment>
            {/* <TableRow> */}

            <TableRow className={open ? 'pf-lt-name team-line' : ''}>
                <TableCell className='pf-icon-wt'>
                    {open ? <ExpandLess onClick={handleClick} /> : <ExpandMore onClick={handleClick} />}
                </TableCell>
                <TableCell className='pf-sec-txt-nme'> {item.employeeName !== null ? item.employeeName : '-'}</TableCell>
                <TableCell title={item.emailId} className='pf-sec-txt-degn txt-off'>{item.emailId !== null ?
                    <Tooltip title={item.emailId} arrow>
                        <span>{item.emailId}</span></Tooltip> : '-'}</TableCell>
                <TableCell className='pf-sec-txt-perd'>{item.designation !== null ? item.designation : '-'}</TableCell>
                <TableCell className='pf-sec-txt-okr'>{item.period !== null ? item.period : '-'}</TableCell>

                <TableCell className='pf-sec-txt-vscor'>{item.okrScore !== null ? item.okrScore : '-'}</TableCell>
                <TableCell className='pf-sec-txt-tscor'>{item.voiceScore !== null ? item.voiceScore : "-"}</TableCell>
                <TableCell className='pf-sec-txt-oscor'>{item.trainingScore !== null ? item.trainingScore : '-'}</TableCell>
                <TableCell className='pf-sec-txt-proposed'>{item.overAllScore !== null ? item.overAllScore : '-'}</TableCell>
                <TableCell className='pf-sec-txt-status'>{item.proposedPercentage !== null ? item.proposedPercentage : '-'}</TableCell>
                <TableCell className='pf-sec-txt-status-name'>{item.statusName !== null ? item.statusName : '-'}</TableCell>
                <TableCell className='pf-sec-txt-btn'>
                    {(parseInt(item.reportingPersonId) == userid) && (parseInt(item.statusId) !== 5) ?
                        <Button className='review' onClick={() => handleView(item.formId, item.statusId, item.reviewerManagerId, item.reportingPersonId)}>Review</Button> :
                        <Button className="view onbt" onClick={() => handleView(item.formId, item.statusId, item.reviewerManagerId, item.reportingPersonId)}>View</Button>
                    }
                    {parseInt(item.statusId) === 3 && (parseInt(item.reviewerManagerId) === userid) ?
                        <Button className='apprval' onClick={() => handleClickOpenDialog(item.formId)}>Approve</Button> :
                        ""
                    }
                    {/* <IconButton className={parseInt(item.reportingPersonId) == userid && parseInt(item.statusId) !== 5 ? 'review' : 'view'} onClick={(e) => toggleMenu(e, item.formId, item.statusId, item.reviewerManagerId, item.reportingPersonId)}>             
                            <MoreHorizIcon />
                        </IconButton> */}
                    {/* <Button >{parseInt(item.reportingPersonId) == userid && parseInt(item.statusId) !== 5 ? "Review" : item.statusId === '3' && parseInt(item.reviewerManagerId) === userid ? 'Approve' : "View"}</Button> */}
                </TableCell>
            </TableRow >
            {
                open ?
                    <TableRow>
                        < TableCell colSpan={12} className='pf-sec-txt' >
                            <div className='lead-tm' >Team of {item.employeeName}</div>
                            <Collapse in={open} timeout="auto" unmountOnExit className='team-line'>
                                <Table className='pf-list-innerlist '>
                                    {children.map((child, key) => (
                                        <Items key={key} item={child} />
                                    ))}
                                </Table>
                            </Collapse>
                        </TableCell >
                    </TableRow >

                    : ''}
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open_Menu}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
            >
                <MenuItem onClick={() => handleView()}>{text}</MenuItem>
                <Divider />
                <MenuItem disabled={isRestrictApprove} onClick={() => handleClickOpenDialog()}>Approve</MenuItem>
            </Menu>

            <Dialog
                open={openDialog}
                onClose={handleCloseDiloag}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to approve this request?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className='theme-btn cancel-btn' onClick={handleCloseDiloag}>No</Button>
                    <Button className='theme-btn' autoFocus onClick={handleForm}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

        </React.Fragment >
    );
};